/**
 * Is «Путь пешки» 2.0 on for this child? The feature 'path-v2' of the session (`GET /api/features`, ../../app/features.ts:
 * account → invite group → site default → env; off on any failure). A developer may also switch it on in a DEV build
 * only with `localStorage['gambit.dev.pathV2'] = '1'` — a production build never reads that key.
 * Off → the old CurriculumScreen at #/path, nothing lost (results stay in their own key).
 */
import { featureOn, useFeature } from '../../app/features.ts';

export const PATH_V2_DEV_KEY = 'gambit.dev.pathV2';

type FlagStorage = Pick<Storage, 'getItem'>;

function browserStorage(): FlagStorage | null {
  try {
    return typeof window === 'undefined' ? null : window.localStorage;
  } catch {
    return null;
  }
}

/** The dev-build override (never in production). Pure. */
export function devPathV2Override(storage: FlagStorage | null = browserStorage(), dev: boolean = import.meta.env.DEV): boolean {
  if (!dev || storage === null) return false;
  try {
    return storage.getItem(PATH_V2_DEV_KEY) === '1';
  } catch {
    return false;
  }
}

/** The server's flag, or the dev override. Pure. */
export function pathV2On(feature: boolean, storage: FlagStorage | null = browserStorage(), dev: boolean = import.meta.env.DEV): boolean {
  return feature || devPathV2Override(storage, dev);
}

/** Right now, outside React. */
export function isPathV2Enabled(): boolean {
  return pathV2On(featureOn('path-v2'));
}

/** In React: follows the features client (a re-read when the page becomes visible again re-renders). */
export function usePathV2(): boolean {
  return pathV2On(useFeature('path-v2'));
}
